import React from "react";
import { connect } from "react-redux";
import FamilyDetail from "../../../../Profile/Home/ProfileInformation/Family/FamilyDetail";
import getMemberFamilyProfile from "../../../../../_selectors/profileSelectors/getMemberFamilyProfile";
import getMemberFamilyIncome from "../../../../../_selectors/profileSelectors/getMemberFamilyIncome";
import { updateObject } from "../../../../../_utils";

const Family = ({ userProfile, showToast, familyIncome }) => {
  return (
    <FamilyDetail
      userProfile={updateObject(userProfile, { familyIncome })}
      showEdit={false}
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  userProfile: getMemberFamilyProfile(state),
  familyIncome: getMemberFamilyIncome(state)
});

export default connect(mapStateToProps)(Family);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileInformation/Family/index.js